(function() { window.GUID_fdfd81c5_2f3e_419e_8e3d_cfcee8f03f2b = { getGuid: function() { return "fdfd81c5-2f3e-419e-8e3d-cfcee8f03f2b"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    let previousRankScopeOverride = null;
                    CS.Controls.Accordion.Events.ContentRefreshed({
                        selector: "body",
                        childSelector: ".accordion-opponents-v2",
                        callback: (accordion, e) => {
                            const $results = accordion.$Content.find(".filter-result.opponent.opponent--player");
                            if ($results.length == 1) {
                                previousRankScopeOverride = "global";
                                WallSections.OpponentsSection.setRankScope("global");
                                $(".leaderboard-rank-scope-toggle-container").hide();
                            }
                            else if (previousRankScopeOverride === "global") {
                                previousRankScopeOverride = "local";
                                WallSections.OpponentsSection.setRankScope("local");
                                $(".leaderboard-rank-scope-toggle-container").show();
                            }
                        },
                    });
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-opponents-v2",
                        callback: (accordion, e) => {
                            var _a, _b, _c;
                            let useFiltersV2 = false;
                            try {
                                useFiltersV2 =
                                    ((_c = ((_b = (_a = accordion.$Content
                                        .find(`#ShowFiltersV2-${accordion.ContentId}`)) === null || _a === void 0 ? void 0 : _a.val()) !== null && _b !== void 0 ? _b : "").toLowerCase()) !== null && _c !== void 0 ? _c : "") == "true";
                            }
                            catch (error) {
                                console.error(error);
                            }
                            CS.Controls.CheckBox.Events.CheckboxValueChanged({
                                selector: "body",
                                childSelector: "#checkbox-leaderboard-rank-scope",
                                callback: (checkbox, e) => {
                                    WallSections.OpponentsSection.setRankScope(checkbox.GetValue() == "true" ? "global" : "local", checkbox);
                                },
                            });
                            accordion.$Content.offon("click.pinResults", "#button-pin-results", (e) => {
                                const $btn = $(e.currentTarget);
                                const { pinUrl, successmsg } = $btn.data("html");
                                if (pinUrl != null) {
                                    accordion.pinSection(pinUrl, accordion, () => {
                                        if (!CS.Helper.isNullOrWhiteSpace(successmsg)) {
                                            CS.Controls.Snackbar.Show({
                                                Id: "pin-toggle-success",
                                                Alignment: CS.Enumeration.SnackbarAlignment.BottomCenter,
                                                Animation: CS.Enumeration.SnackbarAnimation.Slide,
                                                Type: CS.Enumeration.SnackbarType.Success,
                                                Message: successmsg,
                                                AutoHideDuration: 3000,
                                            });
                                        }
                                    });
                                }
                            });
                            if (!WallSections.OpponentsSection.isWallLayout) {
                                WallSections.OpponentsSection.removeLazyloadingTrigger(accordion);
                                return;
                            }
                            const { instance } = WallSections.OpponentsSection;
                            instance._filtersUIFreezed = false;
                            instance._filtersAreCollapsed = accordion.$Content
                                .find(".filters")
                                .hasClass("collapsed");
                            WallSections.OpponentsSection.toggleCustomPresetVisibility(WallSections.OpponentsSection.filtersAreCollapsed);
                            //=================================================================================//
                            //============================// Lazyloading setup
                            WallSections.OpponentsSection.setLazyloadingUrl(accordion);
                            const $lazyloadingTrigger = $(".button-lazy-loader-trigger");
                            if ($lazyloadingTrigger.length)
                                CS.Lag(`${accordion.ControlId}-lazyload`, 500, () => $lazyloadingTrigger.trigger("click"));
                            //=================================================================================//
                            //============================// Floating Spare Status
                            accordion.$Content.offon("click.myFloatingSpareStatus", "#button-my-floating-spare-status", (e) => {
                                const $btn = $(e.currentTarget);
                                const { popupUrl } = $btn.data("html");
                                if (popupUrl != null) {
                                    CS.Controls.Popup.ShowAjaxModal(popupUrl, null, ({ popup, isPopup }) => {
                                        if (!isPopup) {
                                            return;
                                        }
                                        const ajaxPostCallback = (e) => {
                                            const $btn = $(e.currentTarget);
                                            const { url } = $btn.data("html");
                                            if (url != null) {
                                                CS.Ajax.Post(url, null, (response) => {
                                                    popup.Proceed = true;
                                                    popup.Close();
                                                });
                                            }
                                        };
                                        popup.$Control.offon("click.floatingSpareAdd", ".button-add-floatingspare", ajaxPostCallback);
                                        popup.$Control.offon("click.floatingSpareRemove", ".button-remove-floatingspare", ajaxPostCallback);
                                    }, ({ popup }) => {
                                        if (popup.Proceed) {
                                            accordion.RefreshContent(() => {
                                                WallSections.OpponentsSection.updateUI(accordion);
                                            });
                                        }
                                    }, true, null, null);
                                }
                            });
                            //=================================================================================//
                            //============================// Show filters event
                            const showFilters = () => window.scrollTo({ behavior: "smooth", top: 0, left: 0 });
                            if (!useFiltersV2) {
                                CS.DOM.$body.offon("click.filtersShortcut", "#section-top .filters", (e) => showFilters());
                                accordion.$Content.offon("click.filtersShortcut", ".chips .chip", (e) => showFilters());
                            }
                            //=================================================================================//
                            //============================// Filters V2
                            if (useFiltersV2) {
                                CS.Controls.FiltersBar.Events.SortItemClicked({
                                    selector: CS.DOM.$body,
                                    childSelector: `#filters-opponents-${accordion.ContentId}-bar`,
                                    callback: (filtersBar, e) => {
                                        const url = WallSections.OpponentsSection.formatSectionUrl(e.data.url, accordion);
                                        accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                            instance._filtersUIFreezed = false;
                                            WallSections.OpponentsSection.updateUI(accordion);
                                            yield filtersBar.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                        }), url);
                                    },
                                });
                                CS.Controls.FiltersBar.Events.ChipClicked({
                                    selector: CS.DOM.$body,
                                    childSelector: `#filters-opponents-${accordion.ContentId}-bar`,
                                    callback: (filtersBar, e) => {
                                        if (filtersBar.uiFreezed)
                                            return;
                                        instance._filtersUIFreezed = true;
                                        const url = WallSections.OpponentsSection.formatSectionUrl(e.data.toggleUrl, accordion);
                                        accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                            filtersBar.uiFreezed = false;
                                            instance._filtersUIFreezed = false;
                                            WallSections.OpponentsSection.updateUI(accordion);
                                            yield filtersBar.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                        }), url);
                                    },
                                });
                            }
                            CS.Controls.FiltersBar.Events.SortItemClicked({
                                selector: CS.DOM.$body,
                                childSelector: useFiltersV2
                                    ? `#filters-opponents-${accordion.ContentId}-bar`
                                    : "#filters-opponents",
                                callback: (filters, e) => {
                                    const url = WallSections.OpponentsSection.formatSectionUrl(e.data.url, accordion);
                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                        instance._filtersUIFreezed = false;
                                        WallSections.OpponentsSection.updateUI(accordion);
                                        yield filters.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                    }), url);
                                },
                            });
                            CS.Controls.Filters.Events.FiltersToggleClicked({
                                selector: CS.DOM.$body,
                                childSelector: useFiltersV2
                                    ? `#filters-drawer-opponents-${accordion.ContentId}-bar`
                                    : "#filters-opponents",
                                callback: (filters, e) => __awaiter(this, void 0, void 0, function* () {
                                    if (e.data.filtersStateSerialized) {
                                        yield filters.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                        if (useFiltersV2) {
                                            const $parentPopup = $(`#popup-filters-drawer-filters-opponents-${accordion.ContentId}-bar`);
                                            const parentPopup = CS.Controls.GetInstance(CS.Controls.Popup, $parentPopup, true);
                                            if (parentPopup != null)
                                                parentPopup.Close();
                                        }
                                    }
                                }),
                            });
                            CS.Controls.Filters.Events.ItemClicked({
                                selector: CS.DOM.$body,
                                childSelector: useFiltersV2
                                    ? `#filters-drawer-opponents-${accordion.ContentId}-bar`
                                    : "#filters-opponents",
                                callback: (filters, e) => {
                                    const url = WallSections.OpponentsSection.formatSectionUrl(e.data.url, accordion);
                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                        instance._filtersUIFreezed = false;
                                        WallSections.OpponentsSection.updateUI(accordion);
                                        yield filters.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                    }), url);
                                    if (useFiltersV2) {
                                        const $parentPopup = $(`#popup-filters-drawer-filters-opponents-${accordion.ContentId}-bar`);
                                        const parentPopup = CS.Controls.GetInstance(CS.Controls.Popup, $parentPopup, true);
                                        if (parentPopup != null)
                                            parentPopup.Close();
                                    }
                                },
                            });
                            CS.DivisionsPicker.OnItemClick(`filters-shortcut-divisions-${accordion.ContentId}`, (divisionId, customUrl, divisionPicker) => __awaiter(this, void 0, void 0, function* () {
                                try {
                                    const $picker = $(`#filters-shortcut-divisions-${accordion.ContentId}`);
                                    const $container = $picker.closest(".divisions-picker-container");
                                    const overridableUrl = $container.attr("data-overridable-url");
                                    const filterType = $container.attr("data-filter-type");
                                    const filtersUrl = yield CS.Controls.Filters.ReplaceValueInOverridableUrl(overridableUrl, divisionId, filterType);
                                    const url = WallSections.OpponentsSection.formatSectionUrl(filtersUrl, accordion);
                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                        instance._filtersUIFreezed = false;
                                        WallSections.OpponentsSection.updateUI(accordion);
                                        const filtersStateSerialized = yield CS.Controls.Filters.ExtractFiltersStateFromUrl(filtersUrl);
                                        yield CS.Controls.Filters.UpdateFiltersStateInBrowserUrlStatic(filtersStateSerialized);
                                    }), url);
                                }
                                catch (error) {
                                    console.error("Error while handling division picker item click", error);
                                }
                            }));
                            CS.Controls.Filters.Events.FilterToggleClicked({
                                selector: CS.DOM.$body,
                                childSelector: useFiltersV2
                                    ? `#filters-drawer-opponents-${accordion.ContentId}-bar`
                                    : "#filters-opponents",
                                callback: (filters, e) => {
                                    const url = WallSections.OpponentsSection.formatSectionUrl(e.data.toggleUrl, accordion);
                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                        instance._filtersUIFreezed = false;
                                        WallSections.OpponentsSection.updateUI(accordion);
                                        yield filters.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                    }), url);
                                    if (useFiltersV2) {
                                        const $parentPopup = $(`#popup-filters-drawer-filters-opponents-${accordion.ContentId}-bar`);
                                        const parentPopup = CS.Controls.GetInstance(CS.Controls.Popup, $parentPopup, true);
                                        if (parentPopup != null)
                                            parentPopup.Close();
                                    }
                                },
                            });
                            CS.Controls.Filters.Events.TextChanged({
                                selector: CS.DOM.$body,
                                childSelector: useFiltersV2
                                    ? `#filters-drawer-opponents-${accordion.ContentId}-bar`
                                    : "#filters-opponents",
                                callback: (filters, e) => {
                                    const filterType = e.data.filterType;
                                    let shouldTriggerUpdate = filterType != CS.Enumeration.FilterType.Name;
                                    const textValue = e.data.value;
                                    console.log(`Filter item text changed: ${textValue}`);
                                    if (!shouldTriggerUpdate) {
                                        const isNullOrWhiteSpace = CS.Helper.isNullOrWhiteSpace(textValue);
                                        const length = isNullOrWhiteSpace ? 0 : textValue.trim().length;
                                        shouldTriggerUpdate = length >= 3 || isNullOrWhiteSpace;
                                    }
                                    if (shouldTriggerUpdate) {
                                        console.log(`Update triggered. Length: ${length}`);
                                        const url = WallSections.OpponentsSection.formatSectionUrl(e.data.url, accordion);
                                        accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                            instance._filtersUIFreezed = false;
                                            WallSections.OpponentsSection.updateUI(accordion);
                                            yield filters.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                        }), url);
                                        if (useFiltersV2) {
                                            const $parentPopup = $(`#popup-filters-drawer-filters-opponents-${accordion.ContentId}-bar`);
                                            const parentPopup = CS.Controls.GetInstance(CS.Controls.Popup, $parentPopup, true);
                                            if (parentPopup != null)
                                                parentPopup.Close();
                                        }
                                    }
                                    else {
                                        console.log(`Update skipped. Length: ${length}`);
                                    }
                                },
                            });
                            const findNameFilterInput = () => $(`input[datafiltertype="${CS.Enumeration.FilterType.Name}"]`).closest(".textbox.control-cs.cs-filter-input");
                            CS.DOM.$body.offon("click.tabmenuopponentsclick", `#tabmenu-opponnets-tab-menu-${accordion.ContentId} .tab-menu-item`, (e) => __awaiter(this, void 0, void 0, function* () {
                                if (instance._filtersUIFreezed)
                                    return;
                                const $item = $(e.currentTarget);
                                if ($item.hasClass("is-highlighted"))
                                    return;
                                const _data = $item.attr("data-html");
                                if (CS.Helper.isNullOrWhiteSpace(_data))
                                    return;
                                const data = JSON.parse(_data);
                                const { OverridableUrl, ToggleUrl, Value, FilterType } = data;
                                const shouldUseToggleUrl = CS.Helper.isNullOrWhiteSpace(OverridableUrl);
                                const _url = shouldUseToggleUrl
                                    ? ToggleUrl
                                    : yield CS.Controls.Filters.ReplaceValueInOverridableUrl(OverridableUrl, Value, FilterType);
                                if (CS.Helper.isNullOrWhiteSpace(_url))
                                    return;
                                const url = WallSections.OpponentsSection.formatSectionUrl(_url, accordion);
                                instance._filtersUIFreezed = true;
                                accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                    instance._filtersUIFreezed = false;
                                    WallSections.OpponentsSection.updateUI(accordion);
                                    CS.Controls.Filters.UpdateFiltersStateInBrowserUrlStatic(yield CS.Controls.Filters.ExtractFiltersStateFromUrl(url));
                                }), url);
                            }));
                            const inputState = {
                                value: "",
                                changedRecently: false,
                            };
                            CS.Controls.TextBox.Events.TextChanged({
                                selector: accordion.$Content,
                                childSelector: `#textbox-opponentsv2sectionviewmodelsearchbarinput-${accordion.ContentId}`,
                                callback: (textbox, e) => {
                                    const $nameFilterInput = findNameFilterInput();
                                    if ($nameFilterInput.length) {
                                        const $filterContainer = $nameFilterInput.closest(".filter-body");
                                        if ($filterContainer.length) {
                                            const nameFilterInput = CS.Controls.GetInstance(CS.Controls.TextBox, $nameFilterInput, true);
                                            if (nameFilterInput != null) {
                                                const textboxValue = textbox.GetValue();
                                                nameFilterInput.SetValue(textboxValue, true);
                                            }
                                        }
                                    }
                                    else {
                                        const $textboxContainer = accordion.$Content.find(`#OpponentsV2SectionViewModelSearchBar-${accordion.ContentId}`);
                                        if (!$textboxContainer.length)
                                            return;
                                        const toggleUrl = $textboxContainer.attr("data-toggle-url");
                                        const overridableUrl = $textboxContainer.attr("data-overridable-url");
                                        const textBoxId = textbox.ControlId;
                                        inputState.changedRecently = true;
                                        CS.Lag(`${textBoxId}-textboxlag`, 1000, () => __awaiter(this, void 0, void 0, function* () {
                                            inputState.changedRecently = false;
                                            const value = textbox.GetValue();
                                            inputState.value = value;
                                            const isNullOrWhiteSpace = CS.Helper.isNullOrWhiteSpace(value);
                                            const length = isNullOrWhiteSpace ? 0 : value.trim().length;
                                            const shouldTriggerUpdate = length >= 3 || isNullOrWhiteSpace;
                                            if (!shouldTriggerUpdate)
                                                return;
                                            const anyInputChangedRecently = inputState.changedRecently;
                                            if (anyInputChangedRecently)
                                                return;
                                            if (CS.Helper.isNullOrWhiteSpace(overridableUrl))
                                                return;
                                            const _url = yield CS.Controls.Filters.ReplaceValueInOverridableUrl(overridableUrl, value, CS.Enumeration.FilterType.Name);
                                            if (CS.Helper.isNullOrWhiteSpace(_url))
                                                return;
                                            const url = WallSections.OpponentsSection.formatSectionUrl(_url, accordion);
                                            instance._filtersUIFreezed = true;
                                            accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                                instance._filtersUIFreezed = false;
                                                WallSections.OpponentsSection.updateUI(accordion);
                                                CS.Controls.Filters.UpdateFiltersStateInBrowserUrlStatic(yield CS.Controls.Filters.ExtractFiltersStateFromUrl(url));
                                            }), url);
                                        }));
                                    }
                                },
                            });
                            //=================================================================================//
                            //============================// Presets filter
                            accordion.$Content.offon("click.toggleSwitchPlayers", `#opponents-section-players-${accordion.ContentId}`, (e) => {
                                const $dropdownItem = CS.DOM.$body.find(`.item[data-filter-type="${CS.Enumeration.FilterType.EntityType}"][data-value="${CS.Enumeration.EntityType.Player}"]`);
                                if ($dropdownItem.length) {
                                    $dropdownItem.trigger("click");
                                }
                            });
                            accordion.$Content.offon("click.toggleSwitchTeams", `#opponents-section-teams-${accordion.ContentId}`, (e) => {
                                const $dropdownItem = CS.DOM.$body.find(`.item[data-filter-type="${CS.Enumeration.FilterType.EntityType}"][data-value="${CS.Enumeration.EntityType.Team}"]`);
                                if ($dropdownItem.length) {
                                    $dropdownItem.trigger("click");
                                }
                            });
                            accordion.$Content.offon("click.toggleSwitchBothEntities", `#opponents-section-both-${accordion.ContentId}`, (e) => {
                                const $filterItem = CS.DOM.$body.find(`.filter[data-filter-type="${CS.Enumeration.FilterType.EntityType}"]`);
                                if ($filterItem.length) {
                                    const $checkbox = $filterItem.find(".checkbox");
                                    if ($checkbox.length) {
                                        const checkbox = CS.Controls.GetInstance(CS.Controls.CheckBox, $checkbox, true);
                                        if (checkbox != null) {
                                            const currentValue = checkbox.GetValue();
                                            if (currentValue == "true") {
                                                $checkbox.trigger("click");
                                            }
                                        }
                                    }
                                }
                            });
                            //=================================================================================//
                            //============================// Show team roster
                            accordion.$Content.offon("click.showTeamRoster", "#checkbox-show-team-roster", (e) => {
                                const $checkbox = $(e.currentTarget);
                                const checkbox = CS.Controls.GetInstance(CS.Controls.CheckBox, $checkbox, true);
                                if (checkbox != null) {
                                    const newValue = checkbox.GetValue().toLowerCase() == "true";
                                    if (newValue) {
                                        accordion.$Content.addClass("show-team-roster");
                                        instance._showTeamRoster = true;
                                    }
                                    else {
                                        accordion.$Content.removeClass("show-team-roster");
                                        instance._showTeamRoster = false;
                                    }
                                }
                            });
                        },
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=opponents-section.ready.js.map
